export enum TILE_BUTTON_TYPE {
  VIEW_AVAILABILITY = 'viewAvailability',
  BOOK = 'book',
}
